/**
 * Strip HTML tags and collapse whitespace for course-template preview labels.
 *
 * @param {string|null|undefined} html
 * @returns {string}
 */
export function stripHtmlToPlainText(html) {
    if (html == null || html === '') {
        return '';
    }

    const raw = String(html);

    // Parse as HTML so entities (&amp;, &nbsp;, …) decode rather than surfacing as literal text.
    if (typeof DOMParser !== 'undefined') {
        const text = new DOMParser().parseFromString(raw, 'text/html').body.textContent ?? '';

        return text.replace(/\s+/g, ' ').trim();
    }

    return raw
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Join activity title and description for course-template view cards with a single space.
 *
 * @param {string|null|undefined} title
 * @param {string|null|undefined} description
 * @returns {string}
 */
export function formatCourseTemplateActivityPreview(title, description) {
    const normalizedTitle = (title ?? '').trim();
    const normalizedDescription = stripHtmlToPlainText(description);

    if (!normalizedTitle) {
        return normalizedDescription;
    }

    if (!normalizedDescription) {
        return normalizedTitle;
    }

    return `${normalizedTitle} ${normalizedDescription}`;
}
